import userReducer from 'redux/reducers/user-reducer';
import marketplacesReducer from 'redux/reducers/marketplaces-reducer';
import groupsReducer from 'redux/reducers/groups-reducer';
import warehousesReducer from 'redux/reducers/warehouses-reducer';
import agenciesReducer from 'redux/reducers/agencies-reducer';

export const rootReducer = {
  user: userReducer,
  marketplaces: marketplacesReducer,
  groups: groupsReducer,
  warehouses: warehousesReducer,
  agencies: agenciesReducer,
};
